import { z } from 'zod';

const porcentajeField = z
  .number()
  .min(0, 'Entre 0 y 100')
  .max(100, 'Entre 0 y 100')
  .nullable();

export const coprocultivoFormSchema = z.object({
  fecha_analisis: z.date({ message: 'Fecha de análisis inválida' }),
  identificacion_muestras: z.string().nullable(),
  alimentacion: z.string().nullable(),
  ultimo_antiparasitario: z.string().nullable(),
  fecha_ultimo_tratamiento: z.date().nullable(),
  comentarios_lote: z.string().nullable(),
  porcentaje_ostertagia: porcentajeField,
  porcentaje_trichostrongylus: porcentajeField,
  porcentaje_cooperia: porcentajeField,
  porcentaje_haemonchus: porcentajeField,
  porcentaje_oesophagostomum: porcentajeField,
  porcentaje_nematodirus: porcentajeField,
  observacion: z.string().nullable(),
});

export type CoprocultivoFormValues = z.infer<typeof coprocultivoFormSchema>;

export type PorcentajeKey = Extract<keyof CoprocultivoFormValues, `porcentaje_${string}`>;
